import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  margin-top: 100px;
  background-color: rgba(0, 0, 0, 0.266);
  padding: 100px 30px;
  max-width: 1200px;
  color: white;
  margin-inline: auto;
  box-sizing: border-box;
  /* padding: 0px 30px 10px; */
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid var(--color-main-text);

  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);
  h1 {
    font-size: 50px;
    font-weight: 500;
  }
  @media (max-width: 1000px) {
    margin-inline: 20px;
  }
`;
export const LinearLine = styled.div`
  height: 1px;
  background: linear-gradient(90deg, #008000, lime, lime);
  margin-bottom: 40px;
  margin-top: 10px;
  width: 100%;
`;
